import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import type { ControlFocusEventData } from '../models/control-focus-event-data';

type SwitchSize = 'small' | 'medium' | 'big';

export const toggleInfoIconMarker = 'toggle-info-icon-mapper';
export const toggleInfoIconWrapperMarker = 'toggle-info-icon-wrapper-mapper';

@Component({
    selector: 'sp-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSwitchComponent {
    readonly infoIconMarker = toggleInfoIconMarker;
    readonly infoIconWrapperMarker = toggleInfoIconWrapperMarker;

    @Input() label: string;
    @Input() isOn: boolean;
    @Input() isLoading = false;
    @Input() size: SwitchSize = 'small';
    // separate size configuration for sm screen size devices
    @Input() smSize: SwitchSize = 'small';
    @Input() labelPosition: 'right' | 'left' = 'right';
    @Input() infoIcon: boolean;
    @Input() withStateLabel: boolean;

    @Output() toggleChange = new EventEmitter<boolean>();
    @Output() controlFocus = new EventEmitter<ControlFocusEventData>();

    get switchStateLabel(): string {
        return this.isOn ? 'On' : 'Off';
    }

    toggle(event: MouseEvent) {
        if (!this.isLoading) {
            event.stopPropagation();
            this.isOn = !this.isOn;

            this.toggleChange.emit(this.isOn);
        }
    }

    onControlFocus(event: MouseEvent) {
        event.stopPropagation();
        this.controlFocus.emit({ triggeredBySmInfoIcon: true });
    }
}
